var map = {
	"./Bild03.jpg": 6260,
	"./Bild04.jpg": 575,
	"./Bild05.jpg": 6290,
	"./Bild08.jpg": 6075,
	"./Bild09.jpg": 1294,
	"./Bild10.jpg": 6660,
	"./Bild11.jpg": 993,
	"./Bild12.jpg": 3238,
	"./Rendering1.jpg": 2453,
	"./Rendering2.jpg": 1466,
	"./Rendering3.jpg": 4119,
	"./Rendering4.jpg": 6684,
	"./Rendering5.jpg": 4057,
	"./Rendering6.jpg": 7918,
	"./Rendering7.jpg": 4379,
	"./Rendering8.jpg": 9472,
	"./Rendering9.jpg": 6573,
	"./soi.jpg": 5281
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8305;